import Button from "@/common/components/Button";
import { ShowHeader } from "@/common/components/ShowHeader";
import useCompany from "@/common/hooks/queries/useCompany";
import { useGoBack } from "@/common/hooks/useGoBack";
import { useMaintenanceWorkflow } from "@/features/privateCompanies/hooks/maintenance/workflows/useMaintenanceWorkflow";
import { ChevronsRightIcon } from "lucide-react";
import { useParams } from "react-router-dom";

interface MaintenanceDirectiveEntryExecutionHeaderProps {
  actions?: JSX.Element;
  showCancelButton?: boolean;
}

const MaintenanceDirectiveEntryExecutionHeader = ({ actions, showCancelButton }: MaintenanceDirectiveEntryExecutionHeaderProps) => {
  const { companyId, workflowId, directiveEntryType } = useParams();

  const goBack = useGoBack();

  const {
    data: company,
    isPending: companyIsPending,
  } = useCompany({
    id: companyId || '',
  });

  const {
    data: workflow,
    isPending: workflowIsPending,
  } = useMaintenanceWorkflow(workflowId);

  return (
    <ShowHeader
      goBack
      goBackProps={{
        fallback: `/companies/${companyId}/maintenance/workflows/${workflowId}/${directiveEntryType}`,
        searchLastRouteFromFallback: true,
      }}
      isLoading={companyIsPending || workflowIsPending}
      title={company?.general_information?.fantasy_name}
      subtitle={(
        <div className="flex items-center gap-2">
          <p>
            Processos de manutenção (OS)
          </p>

          <ChevronsRightIcon />

          <p>
            {workflow?.id.split('-')[0].toUpperCase() || ''}
          </p>

          <ChevronsRightIcon />

          <p className="text-white-800">
            Vistoria
          </p>
        </div>
      )}
      titleClassName="text-md"
      className="text-white-400"
      subtitleClassName="text-nowrap font-medium"
      buttons={(
        <div className="flex items-center gap-3">
          {showCancelButton && (
            <Button
              variant="outline-error"
              onClick={() => goBack({
                fallback: `/companies/${companyId}/maintenance/workflows/${workflowId}/${directiveEntryType}`,
                searchLastRouteFromFallback: true,
              })}
            >
              Cancelar
            </Button>
          )}

          {actions}
        </div>
      )}
    />
  );
}

export default MaintenanceDirectiveEntryExecutionHeader;
